import moment, { Moment } from 'moment';
import momenttz from 'moment-timezone';
const timezone = 'America/New_York';

export const formatDateMMMDDYYYY = (
    date: Date | string | null,
    startOf: moment.unitOfTime.StartOf = 'day',
    format = 'MMM DD YYYY'
): string => {
    if (!date) return null;
    if (!(date instanceof Date)) date = new Date(date);

    return moment({ 
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate() 
    }).startOf(startOf)
        .format(format);
};

export const shortFormatDate = (date: string | Moment): string => {
    return date ? moment(date).format('MMM DD YYYY') : '';
};

export const shortFormatDateNoYear = (date: string | Moment): string => {
    return date ? moment(date).format('MMM DD') : '';
};

export const longFormatDate = (date: string | Moment): string => {
    return date ? moment(date).format('MMMM Do YYYY') : '';
};

type TimeUnit = 'seconds' | 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
export const dateDifference = (fromDate: string| Date, toDate:string | Date, unit: TimeUnit): number => {
    return moment(fromDate).diff(moment(toDate), unit);
};

export const subtractTimePeriod = (startDate: string | Date, interval: number, metric: TimeUnit, format?: 'YYYY-MM-DD' ): string => {
    return moment(startDate).subtract(interval, metric).format(format);
};

const nonBreakingSpace = '\xa0';
export const longFormatDateTime = (date: string | Moment): string => {
    return date ? moment(date).format(`MMMM Do YYYY h:mm${nonBreakingSpace}a`) : '';
};

export const shortFormatDateTime = (date: string | Moment): string => {
    return date ? moment(date).format('MMM DD YYYY h:mma') : '';
};

export const shortFormatTime = (date: string): string => {
    return date ? moment(date).format('h:mm a') : '';
};

export const formatFromDateForAPIRequestUTC = (date: Date | string, startOf: moment.unitOfTime.StartOf = 'day'): string => {

    momenttz.tz.setDefault(timezone);

    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return momenttz({ year: date.getFullYear(), month: date.getMonth(), day: date.getDate() }).startOf(startOf).utc().format();
};

export const formatToDateForAPIRequestUTC = (date: Date | string, endOf: momenttz.unitOfTime.StartOf = 'day'): string => {

    momenttz.tz.setDefault(timezone);

    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return momenttz({ year: date.getFullYear(), month: date.getMonth(), day: date.getDate() }).endOf(endOf).utc().format();
};

export const getClientFormattedDate = (dateStr: string): string => {
    const clientTz = moment.tz.guess();
    return moment(dateStr).tz(clientTz).format('MMMM  Do YYYY');
};

export const getClientFormattedDateShort = (dateStr: string): string => {
    const clientTz = moment.tz.guess();
    return moment(dateStr).tz(clientTz).format('MMM  Do YYYY');
};

export const getYear = (date: string): string => {
    return date ? new Date(date).getFullYear().toString() : '';
};

export const getAppDate = () => {
    momenttz.tz.setDefault(timezone);
    return momenttz();
};

export const formatDateForXLSXFileName = () => {
    const dateStr = moment().format('YYYY-MM-DD');
    return dateStr;
};
